import axios from 'axios';

export const getDeviceHeaders = async () => {
  let ip = '';
  let location = '';

  try {
    // Fetch public IP address and location using ipapi.co
    const res = await axios.get('https://ipapi.co/json/', { timeout: 2000 });
    ip = res.data.ip;
    // Construct a location string (e.g., "City, Country")
    location =
      res.data.city && res.data.country_name
        ? `${res.data.city}, ${res.data.country_name}`
        : res.data.country_name || '';
  } catch (error) {
    console.error('Failed to fetch IP and location from ipapi', error);

    // Fallback to ipify if ipapi fails (to at least get the IP)
    try {
      const fallbackRes = await axios.get('https://api.ipify.org?format=json', { timeout: 2000 });
      ip = fallbackRes.data.ip;
    } catch (innerError) {
      console.error('Failed to fetch fallback IP', innerError);
    }
  }

  return {
    'x-client-ip': ip,
    'x-device-info': formatUserAgent(navigator.userAgent),
    'x-location': location,
  };
};

export const formatUserAgent = (userAgent: string | undefined | null): string => {
  if (!userAgent) return 'Unknown';
  // Often format is "Mozilla/5.0 (...) AppleWebKit/... (...) Chrome/..."
  // Splitting by ") " usually gives the browser info in the last element.
  const parts = userAgent.split(') ');
  if (parts.length > 1) {
    return parts[parts.length - 1].trim();
  }
  return userAgent;
};
